import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';
import {
    GridRowModes,
    DataGrid,
    GridToolbarContainer,
    GridActionsCellItem,
    GridRowEditStopReasons,
} from '@mui/x-data-grid';
import { Grid } from '@mui/material'
import Pagination from '@mui/material/Pagination'
import Stack from '@mui/material/Stack'
import {
    randomCreatedDate,
    randomTraderName,
    randomId,
    randomArrayItem,
} from '@mui/x-data-grid-generator';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../components/Loader'
import { addSchool, addVehicle, deleteSchool, deleteVehicle, editSchool, editVehicle, schoolList, vehicleList } from '../../actions/settings';

const roles = ['Market', 'Finance', 'Development'];
const randomRole = () => {
    return randomArrayItem(roles);
};

const initialRows = [
    {
        id: randomId(),
        name: randomTraderName(),

    },
    {
        id: randomId(),
        name: randomTraderName(),

    },
    {
        id: randomId(),
        name: randomTraderName(),

    },
    {
        id: randomId(),
        name: randomTraderName(),

    },
    {
        id: randomId(),
        name: randomTraderName(),

    },
];
function EditToolbar(props) {
    const { setRows, setRowModesModel, settings } = props;
    const handleClick = () => {
        const id = randomId();
        setRows((oldRows) => [{ id, name: '', isNew: true }, ...settings.list,]);
        setRowModesModel((oldModel) => ({
            ...oldModel,
            [id]: { mode: GridRowModes.Edit, fieldToFocus: 'name' },
        }));
    };

    return (
        <GridToolbarContainer>
            <Button color="primary" style={{ color: "#442580", fontWeight: "bold" }} className="btn btn-primary btn-block merchantAddButton" startIcon={<AddIcon />} onClick={handleClick}>
                Add New
            </Button>
        </GridToolbarContainer>
    );
}



const MasterManagment = () => {
    const settings = useSelector((state) => state.settings)

    const [rows, setRows] = React.useState(settings?.list);
    const [rowModesModel, setRowModesModel] = React.useState({});
    const loaders = useSelector((state) => state.loader)
    const [filter, setFilter] = useState(0);
    const handleRowEditStop = (params, event) => {
        if (params.reason === GridRowEditStopReasons.rowFocusOut) {
            event.defaultMuiPrevented = true;
        }
    };
    const dispatch = new useDispatch();
    const [data, setData] = useState([])
    const [limit, setLimit] = useState(10)
    const [page, setPage] = useState(1)
    const [deleteIds, setDeleteIds] = useState([])

    useEffect(() => {
        setRows(settings?.list)
    }, [filter, settings])

    const setNewPage = (page) => {
        setPage(page)
        // setDeleteButton(false)
        // setDeleteIds([])

    }
    const updatePagination = (e) => {
        setLimit(e.target.value)
        setPage(1)
        // setDeleteButton(false)
        // setDeleteIds([])
    }
    useEffect(() => {
        const params = { page: page, limit: limit }
        if (filter == 0) {
            dispatch(
                schoolList(params, (res) => {
                    setRows(settings?.list)

                }),
            )

        }
        else {
            dispatch(
                vehicleList(params, (res) => {
                    setRows(settings?.list)

                }),
            )
        }
    }, [limit, page, filter])


    const handleEditClick = (id) => {
        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
    };

    const handleSaveClick = (id) => {
        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
    };

    const handleDeleteClick = (id) => {
        const params = { limit: limit, page: page }
        if (filter == 0) {
            dispatch(deleteSchool({ id }, (res) => {
                dispatch(schoolList(params, (res) => { }))
            }))
        }
        else {
            dispatch(deleteVehicle({ id }, (res) => {
                dispatch(vehicleList(params, (res) => { }))
            }))
        }
        // setRows(rows.cfilter((row) => row.id !== id));
    };

    const handleCancelClick = (id) => {
        setRowModesModel({
            ...rowModesModel,
            [id]: { mode: GridRowModes.View, ignoreModifications: true },
        });

        const editedRow = rows.find((row) => row.id === id);
        if (editedRow.isNew) {
            setRows(settings.list.filter((row) => row.id !== id));
        }
    };

    const processRowUpdate = (newRow) => {
        const updatedRow = { ...newRow, isNew: false };
        setRows(settings.list.map((row) => (row.id === newRow.id ? updatedRow : row)));
        if (filter == 0) {
            var editedRow = settings.list.find((row) => row.id === newRow.id)
            if (editedRow) {
                dispatch(
                    editSchool({ id: newRow.id, name: newRow.name }, (res) => {
                        const params = { page: page, limit: limit }

                        dispatch(
                            schoolList(params, (res) => { }),
                        )
                    }),
                )
            }
            else {
                dispatch(
                    addSchool({ name: newRow.name }, (res) => {
                        const params = { page: page, limit: limit }

                        dispatch(
                            schoolList(params, (res) => { }),
                        )
                    }),
                )
            }
        }
        else {
            var editedRow = settings.list.find((row) => row.id === newRow.id)
            if (editedRow) {
                dispatch(
                    editVehicle({ id: newRow.id, name: newRow.name, mpg: newRow.mpg, greenhouse_gas_emission: newRow.greenhouse_gas_emission }, (res) => {
                        const params = { page: page, limit: limit }

                        dispatch(
                            vehicleList(params, (res) => { }),
                        )
                    }),
                )
            }
            else {
                dispatch(
                    addVehicle({ name: newRow.name, mpg: newRow.mpg, greenhouse_gas_emission: newRow.greenhouse_gas_emission }, (res) => {
                        const params = { page: page, limit: limit }

                        dispatch(
                            vehicleList(params, (res) => { }),
                        )
                    }),
                )
            }
        }
        return updatedRow;
    };

    const handleRowModesModelChange = (newRowModesModel) => {
        setRowModesModel(newRowModesModel);
    };

    const vehicleColumns = [
        { field: 'name', headerName: 'Name', width: 200, editable: true },
        { field: 'mpg', headerName: 'MPG', width: 100, editable: true },
        { field: 'greenhouse_gas_emission', headerName: 'Greenhouse Gas Emission', width: 200, editable: true },
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Actions',
            width: 300,
            cellClassName: 'actions',
            getActions: ({ id }) => {
                const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;

                if (isInEditMode) {
                    return [
                        <GridActionsCellItem
                            icon={<SaveIcon />}
                            label="Save"
                            sx={{
                                color: 'primary.main',
                            }}
                            onClick={() => handleSaveClick(id)}
                        />,
                        <GridActionsCellItem
                            icon={<CancelIcon />}
                            label="Cancel"
                            className="textPrimary"
                            onClick={() => handleCancelClick(id)}
                            color="inherit"
                        />,
                    ];
                }

                return [
                    <GridActionsCellItem
                        icon={<EditIcon />}
                        label="Edit"
                        className="textPrimary"
                        onClick={() => handleEditClick(id)}
                        color="inherit"
                    />,
                    <GridActionsCellItem
                        icon={<DeleteIcon />}
                        label="Delete"
                        onClick={() => handleDeleteClick(id)}
                        color="inherit"
                    />,
                ];
            },
        },
    ];


    const columns = [
        { field: 'name', headerName: 'Name', width: 500, editable: true },
        // if(filter == 1) {
        // { field: 'name',  headerName: 'Name', width: 300, editable: true },
        // { field: 'name', headerName: 'Name', width: 300, editable: true },
        // }
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Actions',
            width: 400,
            cellClassName: 'actions',
            getActions: ({ id }) => {
                const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;

                if (isInEditMode) {
                    return [
                        <GridActionsCellItem
                            icon={<SaveIcon />}
                            label="Save"
                            sx={{
                                color: 'primary.main',
                            }}
                            onClick={() => handleSaveClick(id)}
                        />,
                        <GridActionsCellItem
                            icon={<CancelIcon />}
                            label="Cancel"
                            className="textPrimary"
                            onClick={() => handleCancelClick(id)}
                            color="inherit"
                        />,
                    ];
                }

                return [
                    <GridActionsCellItem
                        icon={<EditIcon />}
                        label="Edit"
                        className="textPrimary"
                        onClick={() => handleEditClick(id)}
                        color="inherit"
                    />,
                    <GridActionsCellItem
                        icon={<DeleteIcon />}
                        label="Delete"
                        onClick={() => handleDeleteClick(id)}
                        color="inherit"
                    />,
                ];
            },
        },
    ];

    return (
        <div className="userPage adminPage merchantlist">
            <Loader loading={loaders.isFetching} />

            {/* <div className="scroll-fix"> */}
            <Grid container spacing={1}>
                <Grid item xs={12} sm={6} md={8}>
                    <div style={{ display: 'flex' }}>
                        <div>
                            <p className="headinguser">Master Management</p>
                            {/* <p className="subheadinggraph">
                    Merchant of Climate Mobility & Safety
                  </p> */}
                        </div>
                    </div>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <select
                        className="selectoptioninmerchant"
                        onChange={(e) => setFilter(e.target.value)}
                        placeholder="Recent Merchants"
                        type="select"
                    >
                        <option selected value={0}>Groups</option>
                        <option value={1}>Vehicles</option>
                        {/* <option value={2}>Community</option> */}
                    </select>
                </Grid>
            </Grid>
            <div className="pagination-settings">
                <div className="pagination">
                    <p>
                        Showing {settings.list.length} out of {settings.total_users}
                    </p>
                </div>

                <Stack spacing={2}>
                    <Pagination
                        count={Math.ceil(settings.total_users / limit)}
                        page={page}
                        onChange={(e, value) => setNewPage(value)}
                        color="primary"
                    />
                </Stack>
                <div className="pagination2">
                    <p>Rows Per Page</p>
                    <select className='pagination-select' onChange={(e) => updatePagination(e)}>
                        <option selected={limit == 5}>5</option>
                        <option selected={limit == 10}>10</option>
                        <option selected={limit == 20}>20</option>
                    </select>
                </div>
            </div>
            <Box
                sx={{
                    height: 500,
                    marginTop: "10px",
                    width: '100%',
                    '& .actions': {
                        color: 'text.secondary',
                    },
                    '& .textPrimary': {
                        color: 'text.primary',
                    },
                }}
            >
                <DataGrid
                    rows={rows}
                    columns={filter == 0 ? columns : vehicleColumns}
                    editMode="row"
                    rowModesModel={rowModesModel}
                    onRowModesModelChange={handleRowModesModelChange}
                    onRowEditStop={handleRowEditStop}
                    processRowUpdate={processRowUpdate}
                    slots={{
                        toolbar: EditToolbar,
                    }}
                    slotProps={{
                        toolbar: { setRows, setRowModesModel, settings },
                    }}
                />
            </Box>
        </div>
        // </div>

    );
}

export default MasterManagment
